import { Grid, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import { messageClose } from 'modules/messages/actions';
import { MessageInfo } from 'modules/messages/types';
import React from 'react';
import { connect } from 'react-redux';
import { cyrb53Hash } from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

interface OwnProps {
  messages: MessageInfo[];
  messageClose: (a: number) => void;
}

const Messages: React.FC<OwnProps> = ({ messages, messageClose }) => {
  const classes = useStyles();

  return (
    <>
      {messages.map((message, id) => (
        <Snackbar
          open
          key={cyrb53Hash(String(message.id))}
          autoHideDuration={8000}
          style={{ marginTop: id * 70 }}
          onClose={() => messageClose(message.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={message.type}
            classes={{ message: classes.message }}
            onClose={() => messageClose(message.id)}
            action={
              message.action && (
                <Grid>
                  <span
                    className={classes.actionButton}
                    onClick={() => {
                      messageClose(message.id);
                      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                      message.action!();
                    }}
                  >
                    {message.labelAction}
                  </span>
                </Grid>
              )
            }
          >
            {message.message}
          </MuiAlert>
        </Snackbar>
      ))}
    </>
  );
};

const mapStateToProps = ({ messages }) => ({
  messages: messages.messagesList,
});

export default connect(mapStateToProps, { messageClose })(Messages);
